<template>
  <nav class="navbar" :class="{ 'navbar--scrolled': currentSection > 0, 'navbar--open': menuOpen }">
    <div class="navbar__inner">
      <!-- Logo -->
      <div class="navbar__logo" @click="$emit('navigate', 0)">
        <span class="navbar__logo-text">Perfume Wiz</span>
      </div>

      <!-- Desktop Menu -->
      <ul class="navbar__menu">
        <li
          v-for="(item, index) in navItems"
          :key="item.label"
          class="navbar__menu-item"
          :class="{ active: currentSection === index }"
          @click="handleNav(index)"
        >
          {{ item.label }}
        </li>
      </ul>

      <!-- Hamburger -->
      <button class="navbar__hamburger" @click="menuOpen = !menuOpen" aria-label="메뉴">
        <span></span>
        <span></span>
        <span></span>
      </button>
    </div>

    <!-- Mobile Menu -->
    <div class="navbar__mobile" :class="{ open: menuOpen }">
      <ul>
        <li
          v-for="(item, index) in navItems"
          :key="item.label"
          @click="handleNav(index)"
        >
          {{ item.label }}
        </li>
      </ul>
    </div>
  </nav>
</template>

<script>
export default {
  name: 'NavBar',
  props: {
    currentSection: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      menuOpen: false,
      navItems: [
        { label: 'Home' },
        { label: 'About' },
        { label: 'Products' },
        { label: 'Process' },
        { label: 'Contact' }
      ]
    }
  },
  methods: {
    handleNav(index) {
      this.$emit('navigate', index)
      this.menuOpen = false
    }
  }
}
</script>

<style lang="scss" scoped>
@import '../../assets/styles/variables';

.navbar {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  z-index: $z-navbar;
  transition: background-color $transition-base, backdrop-filter $transition-base;

  &--scrolled {
    background-color: rgba($color-forest, 0.88);
    backdrop-filter: blur(12px);
  }
}

.navbar__inner {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 24px 60px;

  @media (max-width: $bp-mobile) {
    padding: 20px 24px;
  }
}

.navbar__logo {
  cursor: pointer;

  &-text {
    font-family: $font-heading;
    font-size: 22px;
    font-weight: 500;
    letter-spacing: 0.08em;
    color: $color-ivory;
    transition: color $transition-base;

    &:hover {
      color: $color-gold;
    }
  }
}

.navbar__menu {
  display: flex;
  gap: 40px;

  @media (max-width: $bp-mobile) {
    display: none;
  }
}

.navbar__menu-item {
  font-family: $font-body;
  font-size: 12px;
  font-weight: 500;
  letter-spacing: 0.15em;
  text-transform: uppercase;
  color: rgba($color-ivory, 0.75);
  cursor: pointer;
  transition: color $transition-base;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 0;
    height: 1px;
    background-color: $color-gold;
    transition: width $transition-base;
  }

  &:hover,
  &.active {
    color: $color-ivory;

    &::after {
      width: 100%;
    }
  }

  &.active::after {
    background-color: $color-gold;
  }
}

.navbar__hamburger {
  display: none;
  flex-direction: column;
  gap: 5px;
  background: none;
  border: none;
  cursor: pointer;
  padding: 4px;

  @media (max-width: $bp-mobile) {
    display: flex;
  }

  span {
    display: block;
    width: 24px;
    height: 1.5px;
    background-color: $color-ivory;
    transition: all $transition-base;
  }
}

.navbar--open .navbar__hamburger {
  span:nth-child(1) {
    transform: translateY(6.5px) rotate(45deg);
  }
  span:nth-child(2) {
    opacity: 0;
  }
  span:nth-child(3) {
    transform: translateY(-6.5px) rotate(-45deg);
  }
}

.navbar__mobile {
  display: none;
  background-color: rgba($color-forest, 0.96);
  backdrop-filter: blur(16px);
  overflow: hidden;
  max-height: 0;
  transition: max-height 0.4s ease;

  @media (max-width: $bp-mobile) {
    display: block;
  }

  &.open {
    max-height: 300px;
  }

  ul {
    padding: 16px 24px 24px;
  }

  li {
    font-family: $font-body;
    font-size: 14px;
    font-weight: 400;
    letter-spacing: 0.12em;
    text-transform: uppercase;
    color: rgba($color-ivory, 0.8);
    padding: 14px 0;
    border-bottom: 1px solid rgba($color-ivory, 0.08);
    cursor: pointer;
    transition: color $transition-base;

    &:last-child {
      border-bottom: none;
    }

    &:hover {
      color: $color-gold;
    }
  }
}
</style>
